import React from 'react';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';

export type UserProfileSelectionListItemProps = {
  to: string | undefined;
  children: React.ReactNode;
  routing?: boolean;
};

export function UserProfileSelectionListItem({ to, children, routing = true }: UserProfileSelectionListItemProps) {
  if (!to || !children) {
    return null;
  }

  return (
    <li className="user-profile-selection__listitem">
      <Hyperlink to={to} className="user-profile-selection__link" routing={routing}>
        {children}
      </Hyperlink>
    </li>
  );
}
